import axios from 'axios'

axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? 'https://kcapi.codetrust.cn/' : 'http://localhost:20184/'
axios.defaults.headers.common['token'] = localStorage.getItem('kaochang.token')
axios.interceptors.response.use(response => {
  return response
}, error => {
  let response = error.response
  if (!response) {
    response = {
      status: 504
    }
  }
  if (!response.data || typeof response.data === 'string') {
    response.data = {
      success: false,
      message: '网络异常,请稍后重试'
    }
  }
  if (response.status === 401) {
    setTimeout(function () {
      localStorage.removeItem('token')
      if (location.href.indexOf('/login') < 0) {
        location.href = '/login?redirect=' + encodeURIComponent(location.href)
      }
    }, 2000) // 2秒后跳转到登录页
  }
  return response
})

// 单据打印服务地址
axios.receiptBaseUrl = (process.env.NODE_ENV === 'production' ?
                        'http://kcapi.codetrust.cn/receipt' :
                        'http://localhost:20184/receipt')

export default axios



// WEBPACK FOOTER //
// ./src/http.js